import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, ArrowLeft, CheckCircle, AlertCircle, Send } from "lucide-react";
import { api } from "../api/greenclub";
const EsqueceuSenha = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      // Validação básica
      if (!email) {
        setError("Por favor, informe seu email");
        return;
      }
      if (!/\S+@\S+\.\S+/.test(email)) {
        setError("Por favor, insira um email válido");
        return;
      }

      const response = await api.requestPasswordReset({ email });
      if (response.success) {
        setEnviado(true);
      } else {
        setError(
          response.error || "Ocorreu um erro ao processar sua solicitação."
        );
      }
    } catch (error) {
      console.error("Erro ao solicitar recuperação:", error);
      setError(
        error.message || "Erro interno. Tente novamente em alguns minutos."
      );
    } finally {
      setLoading(false);
    }
  };
  if (enviado) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100 flex items-center justify-center p-4"
      >
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Email Enviado!
          </h2>
          <p className="text-gray-600 mb-6">
            Enviamos um link para recuperação de senha para{" "}
            <strong>{email}</strong>. Verifique sua caixa de entrada e siga as
            instruções.
          </p>
          <div className="space-y-3">
            <motion.a
              href="/"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="w-full bg-emerald-600 text-white py-3 rounded-lg font-medium hover:bg-emerald-700 transition-colors inline-block"
            >
              Voltar ao Login
            </motion.a>
            <motion.button
              onClick={() => {
                setEnviado(false);
                setEmail("");
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200 transition-colors"
            >
              Enviar para outro email
            </motion.button>
          </div>
          <p className="text-xs text-gray-500 mt-4">
            Não recebeu o email? Verifique sua pasta de spam ou tente novamente
            em alguns minutos.
          </p>
        </div>
      </motion.div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100 flex items-center justify-center p-4"
    >
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        {/* Header */}
        <div className="mb-8">
          <motion.a
            href="/"
            whileHover={{ x: -5 }}
            className="inline-flex items-center text-emerald-700 hover:text-emerald-800 transition-colors mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao Login
          </motion.a>

          <div className="text-center">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Esqueceu sua senha?
            </h1>
            <p className="text-gray-600">
              Informe seu email para receber um link de recuperação de senha
            </p>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Error Message */}
          <AnimatePresence>
            {error && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-center space-x-3"
              >
                <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
                <p className="text-red-800 text-sm">{error}</p>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email cadastrado
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                placeholder="seu.email@exemplo.com"
                required
              />
            </div>
          </div>

          {/* Submit Button */}
          <motion.button
            type="submit"
            disabled={loading}
            whileHover={{ scale: loading ? 1 : 1.02 }}
            whileTap={{ scale: loading ? 1 : 0.98 }}
            className="w-full bg-emerald-600 text-white py-3 rounded-lg font-medium hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center space-x-2"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            ) : (
              <>
                <Send className="w-5 h-5" />
                <span>Enviar Link de Recuperação</span>
              </>
            )}
          </motion.button>
        </form>

        {/* Instructions */}
        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <h3 className="text-sm font-medium text-blue-800 mb-2">
            Como funciona:
          </h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• Informe o email usado no seu cadastro</li>
            <li>• Você receberá um link seguro por email</li>
            <li>• Clique no link para definir uma nova senha</li>
            <li>• O link expira em 24 horas</li>
          </ul>
        </div>

        {/* Contact Support */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Problemas para recuperar sua conta?{" "}
            <a
              href="mailto:suporte@greenclub.com"
              className="text-emerald-600 hover:text-emerald-700 font-medium"
            >
              Entre em contato
            </a>
          </p>
        </div>
      </div>
    </motion.div>
  );
};
export default EsqueceuSenha;
